module.exports = __webpack_public_path__ + "img/google.6f6e594f.svg";